module.exports = __webpack_public_path__ + "img/mana2.9ef445ad.png";